import { Flex, Grid, Typography } from "antd";
import { CSSProperties, FC } from "react";
import './index.scss'

type StylesType = 'title' | 'subtitle' | 'wrapper'

interface Props {
  title: string
  subtitle?: string
  styles?: Record<StylesType, CSSProperties>
}

export const Header: FC<Props> = ({ title, subtitle, styles }) => {
  const { lg } = Grid.useBreakpoint()

  return (
    <Flex className={'my-profile-header'} vertical gap={16} style={styles?.wrapper}>
      <Typography.Title className={'title'} level={lg ? 1 : 2} style={styles?.title}>
        {title}
      </Typography.Title>

      {subtitle && <Typography.Text className={'subtitle'} style={styles?.subtitle}>
        {subtitle}
      </Typography.Text>}
    </Flex>
  )
}